import script from "./ViewAlnspectionTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAlnspectionTeam.vue?vue&type=script&setup=true&lang=js"

import "./ViewAlnspectionTeam.vue?vue&type=style&index=0&id=62917566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62917566"]])

export default __exports__